import Model, { attr, hasMany } from '@ember-data/model';
import CampaignLineItemModel from './campaign-line-item';

export default class LineItemModel extends Model {
  @attr('string') contactId?: string;
  @attr('string') pledgeId?: string;
  @attr('date-only') declare transDate: Date;
  @attr('string') transType?: string;
  @attr('string') memo?: string;
  @attr('number') declare amount: number;
  @attr('boolean') declare isManual: boolean;
  @attr() custom?: any;
  @attr('boolean') declare anonymous: boolean;
  @hasMany('campaign-line-item', { async: false, inverse: null })
  campaignLineItems?: CampaignLineItemModel[];

  get campaignLineItemsArray() {
    return this.campaignLineItems?.slice() || [];
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'line-item': LineItemModel;
  }
}
